import {useQuery} from '@tanstack/vue-query';
import axios from 'axios';

const usePausedPrice = () => useQuery({
  queryKey: ['paused-price'],
  queryFn: async () => {
    const {data} = await axios.get('/ajax/v2/billing/package/website/paused-price');
    return data.paused_price;
  },
});

export {
  usePausedPrice,
};
